import { Flame, Twitter, Sparkles } from 'lucide-react';

import { TaskCategory } from '../types';

import { useNewYearTasks } from '@/hooks/useNewYearCampaign';

interface TaskSidebarProps {
  activeCategory: TaskCategory | null;
  onCategoryChange: (category: TaskCategory | null) => void;
}

const CATEGORIES = [
  {
    id: null as TaskCategory | null,
    label: 'All Tasks',
    icon: Sparkles,
    color: 'cyan',
  },
  {
    id: TaskCategory.PLATFORM,
    label: 'Junk Fun Tasks',
    icon: Flame,
    color: 'orange',
  },
  {
    id: TaskCategory.TWITTER,
    label: 'X Tasks',
    icon: Twitter,
    color: 'cyan',
  },
  {
    id: TaskCategory.SPECIAL,
    label: 'Special Tasks',
    icon: Sparkles,
    color: 'purple',
  },
];

export function TaskSidebar({
  activeCategory,
  onCategoryChange,
}: TaskSidebarProps) {
  // Get task counts by category
  const { data: tasksData } = useNewYearTasks();
  const tasks = tasksData?.tasks || [];

  const getTaskCount = (category: TaskCategory | null): number => {
    if (category === null) {
      return tasks.filter((t) => !t.isCompleted).length;
    }
    return tasks.filter((t) => t.category === category && !t.isCompleted).length;
  };

  return (
    <div className="w-full md:w-48 flex-shrink-0">
      <div className="flex md:flex-col gap-2 overflow-x-auto md:overflow-x-visible pb-2 md:pb-0">
        {CATEGORIES.map((cat) => {
          const Icon = cat.icon;
          const isActive = activeCategory === cat.id;
          const count = getTaskCount(cat.id);

          return (
            <button
              key={cat.id || 'all'}
              onClick={() => onCategoryChange(cat.id)}
              className={`flex items-center gap-2 px-3 py-2 rounded-lg whitespace-nowrap transition-colors ${
                isActive
                  ? `bg-${cat.color}-500/20 border border-${cat.color}-500/50 text-${cat.color}-400`
                  : 'bg-gray-800/50 border border-gray-700 text-gray-400 hover:bg-gray-700/50'
              }`}
            >
              <Icon className="w-4 h-4 flex-shrink-0" />
              <span className="text-sm font-medium">{cat.label}</span>
              {count > 0 && (
                <span
                  className={`ml-auto px-2 py-0.5 rounded-full text-xs ${
                    isActive
                      ? `bg-${cat.color}-500/30 text-${cat.color}-300`
                      : 'bg-gray-700 text-gray-400'
                  }`}
                >
                  {count}
                </span>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}
